/**
 * Hungarian language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_HU_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'Profilom',
    'lvt.menu.tw_profile': 'TW Profile',
    'lvt.menu.company_profile': 'Vállalati profil',
    'lvt.menu.my_notifications': 'Értesítéseim',
    'lvt.menu.sign_out': 'Kijelentkezés',

    // footer
    'lvt.footer.back_to_top': 'Vissza a tetejére',
    'lvt.footer.terms_of_use': 'Felhasználási feltételek',
    'lvt.footer.privacy_policy': 'Adatvédelmi szabályzat',
    'lvt.footer.support_information': 'Segédinformáció',
    'lvt.footer.transwide_home': 'Transwide főmenü',
    'lvt.footer.license_nr': 'Engedélysz.:',
    'lvt.footer.build_version': 'Felépítés változata:',

    // order list columns
    'lvt.order_list.header': 'Megrendelés lista',
    'lvt.order_list.column.shipperCompany': 'Szállítmányozó vállalat',
    'lvt.order_list.column.reference': 'Referencia',
    'lvt.order_list.column.status': 'Állapot',
    'lvt.order_list.column.statusReason': 'Állapot oka',
    'lvt.order_list.column.senderCompany': 'Feladó vállalat',
    'lvt.order_list.column.senderZipcode': 'Feladó irányítószáma',
    'lvt.order_list.column.senderCity': 'Feladó városa',
    'lvt.order_list.column.receiverCompany': 'Címzett vállalat',
    'lvt.order_list.column.receiverZipcode': 'Címzett irányítószáma',
    'lvt.order_list.column.receiverCity': 'Címzett városa',
    'lvt.order_list.column.carrierName': 'Szállító neve',
    'lvt.order_list.column.plannedPickupEndDate': 'Tervezett felvétel',
    'lvt.order_list.column.etaPickup': 'ETA a felvételnél',
    'lvt.order_list.column.delayAtPickup': 'Késés a felvételnél',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Tervezett kézbesítés',
    'lvt.order_list.column.etaDelivery': 'ETA a kézbesítésnél',
    'lvt.order_list.column.delayAtDelivery': 'Késés a kézbesítésnél',
    'lvt.order_list.column.timestamps': 'Időbélyegzők',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Kért',
    'lvt.order_list.status.failed': 'Hiba',
    'lvt.order_list.status.waiting': 'Várakozás',
    'lvt.order_list.status.active': 'Aktív',
    'lvt.order_list.status.stopped': 'Hiba',
    'lvt.order_list.status.completed': 'Teljesített',
    'lvt.order_list.status.cancelled': 'Törölt',
    'lvt.order_list.status.timeout': 'Leállított',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Nincs kijelölve szállító',
    'lvt.order_list.status_reason.plate_number_not_present': 'A rendszám nincs jelen',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'A rendszám nem ismerhető fel',
    'lvt.order_list.status_reason.plate_number_not_operational': 'A rendszám nem használható',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Technical error when creating the tour in GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'sor oldalanként',
    'lvt.order_list.pagination.first': 'Első',
    'lvt.order_list.pagination.previous': 'Előző',
    'lvt.order_list.pagination.next': 'Következő',
    'lvt.order_list.pagination.last': 'Utolsó',
    'lvt.order_list.pagination.no_orders_found': 'Nem található megrendelés',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Pótkocsi',
    'lvt.map.tracked_device.tractor': 'Vontató',
    'lvt.map.tracked_device.mobile': 'Mobil',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'Megrendelési lista megnyitása',
    'lvt.map.traffic_information.traffic': 'Traffic',
    'lvt.map.traffic_information.fast': 'Fast',
    'lvt.map.traffic_information.slow': 'Slow',
    'lvt.map.pickup_popup.pickup': 'Felvétel',
    'lvt.map.pickup_popup.date': 'Dátum',
    'lvt.map.pickup_popup.address': 'Cím',
    'lvt.map.delivery_popup.delivery': 'Kézbesítés',
    'lvt.map.delivery_popup.date': 'Dátum',
    'lvt.map.delivery_popup.address': 'Cím',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'Úton a kézbesítéshez',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'Úton a felvételhez',
    'lvt.map.current_gps_popup.current_speed': 'Aktuális sebesség',
    'lvt.map.current_gps_popup.average_speed': 'Átlagos sebesség',
    'lvt.map.current_gps_popup.last_location_update': 'Elhelyezkedés legutóbbi frissítése',
    'lvt.map.current_gps_popup.eta': 'ETA',
    'lvt.map.current_gps_popup.planned_time': 'Tervezett idő',
    'lvt.map.current_gps_popup.arrival_delay': 'Érkezési késés',
    'lvt.map.current_gps_popup.speed_unit': 'km/h',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Megérkezett a kiindulási helyszínre',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'Nem érkezett meg a kiindulási helyszínre',
    'lvt.order_list.timestamp.left_origin': 'Elhagyta a kiindulás helyszínét',
    'lvt.order_list.timestamp.not_left_origin': 'Nem hagyta el a kiindulás helyszínét',
    'lvt.order_list.timestamp.arrived_at_destination': 'Megérkezett a célállomásra',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'Nem érkezett meg a célállomásra',
    'lvt.order_list.timestamp.left_destination': 'Elhagyta a célállomást',
    'lvt.order_list.timestamp.not_left_destination': 'Nem hagyta el a célállomást',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-hu.ts